"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = require("utils/debug");
var WebSiteStore_1 = require("mobile/models/WebSiteStore");
var WebSiteStore = WebSiteStore_1.getStore();
var ssrcontext_1 = require("../ssrcontext");
var generateDomain = function generateDomain(prefix) {
    if (prefix === void 0) { prefix = ""; }
    if (ssrcontext_1.runInServer()) {
        return ssrcontext_1.getSnapshootByKey("api");
    }
    if (prefix !== "") {
        prefix = prefix + ".";
    }
    var apiDomain = WebSiteStore.getParams("apiDomain");
    if (apiDomain) {
        return apiDomain;
    }
    if (debug_1.isUAT()) {
        return prefix + ".kdev0-api.65emall.net";
    }
    else if (debug_1.isLTDomain() || debug_1.isLitbOukuDomain()) {
        return "" + prefix + location.hostname
            .split(".")
            .slice(-2)
            .join(".");
    }
    else {
        var hostname = window.location.hostname;
        var idx = hostname.indexOf("ezbuy");
        if (idx > -1) {
            var suffix = hostname.slice(idx);
            return prefix + suffix;
        }
        return prefix + "ezbuy.sg";
    }
};
exports.default = generateDomain;
